import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const contractService = {
  get_all: async (search = "", token) => {
    const response = await https.get(
      `${API_ROUTES.CONTRACT.GET_ALL}?search_value=${search}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  get_by_id: async (id, token) => {
    const response = await https.get(`${API_ROUTES.CONTRACT.GET_BY_ID}/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  },
};
